import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../shared/api/client';
import { Card } from '../shared/ui/Card';
import { StatTile } from '../shared/ui/StatTile';
import { StatusBadge, statusToneFromEnum } from '../shared/ui/StatusBadge';

export function PlatformDashboardPage() {
  const { t } = useTranslation();
  const dash = useQuery({
    queryKey: ['platform-dashboard'],
    queryFn: () => api.platformDashboard(),
  });

  if (dash.isError) {
    return <div className="alert alert-danger">{(dash.error as Error).message}</div>;
  }

  const d = dash.data?.data;

  return (
    <>
<div className="row g-3 mb-4">
        <div className="col-sm-6 col-md-3">
          <StatTile
            tone="primary"
            icon="bi-buildings"
            label={t('platform.dashboard.tenants')}
            value={d != null ? String(d.tenantsTotal) : '—'}
          />
        </div>
        <div className="col-sm-6 col-md-3">
          <StatTile
            tone="success"
            icon="bi-check2-circle"
            label={t('platform.dashboard.active')}
            value={d != null ? String(d.tenantsActive) : '—'}
          />
        </div>
        <div className="col-sm-6 col-md-3">
          <StatTile
            tone="info"
            icon="bi-people"
            label={t('platform.dashboard.users')}
            value={d != null ? String(d.usersTotal) : '—'}
          />
        </div>
        <div className="col-sm-6 col-md-3">
          <StatTile
            tone="warning"
            icon="bi-ticket-perforated"
            label={t('platform.dashboard.openSessions')}
            value={d != null ? String(d.openSessionsTotal) : '—'}
          />
        </div>
      </div>

      <Card title={t('platform.dashboard.recent')}>
        <div className="d-grid gap-2">
          {(d?.recentTenants ?? []).map((ten) => (
            <div
              key={ten.id}
              className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-2 py-2 border-bottom"
            >
              <div>
                <strong>{ten.slug}</strong> — {ten.name}
              </div>
              <div className="d-flex flex-wrap align-items-center gap-2 text-muted small">
                <StatusBadge tone={statusToneFromEnum(ten.status)}>{ten.status}</StatusBadge>
                <span>
                  {ten.usersCount} users · {ten.parkingsCount} parkings
                </span>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </>
  );
}
